import { takeEvery, all, call, put, cancelled } from 'redux-saga/effects';

import {
  PRODUCTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD,
  PRODUCTS_MASSIVE_UPLOAD_REQUEST_VERIFY,
  PRODUCTS_MASSIVE_UPLOAD_REQUEST_UPLOAD,
  productsMassiveUploadSetAllowUpload,
  productsMassiveUploadClearAllowUpload,
  productsMassiveUploadSetVerify,
  productsMassiveUploadClearVerify,
  productsMassiveUploadClearUpload,
} from '../actions';

import instance from 'services/request';

import { responseOK } from 'Domains/SalesChallengeRefactor/utils';

import { productsMassiveUpload } from '../../services';
import {
  fileTo64String,
  validateTypeAndSize,
  summaryModal,
  summaryEndModal,
} from 'common/MassiveUploads/utils';
import { messageError } from 'utils/messages';

function* workProductsMassiveUploadSetAllowUpload(action) {
  try {
    yield productsMassiveUploadSetAllowUpload(action.payload);
  } catch (error) {
    yield productsMassiveUploadClearAllowUpload();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield productsMassiveUploadClearAllowUpload();
    }
  }
}

function* workProductsMassiveUploadRequestVerify({ payload }) {
  const { file, setFileString } = payload;
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();
  try {
    const isValidFile = validateTypeAndSize(file);
    if (!isValidFile) {
      messageError(
        'El formato del archivo de carga masiva de productos debe ser .xlsx y tener un tamaño máximo de 20 MB.'
      );

      return;
    }

    const file64Str = yield call(fileTo64String, file);
    yield call(setFileString, file64Str);
    const response = yield call(productsMassiveUpload, {
      cancelToken: source.token,
      data: {
        content: file64Str,
        overwrite: false,
        save: false,
      },
    });
    if (responseOK(response)) {
      const { data, message, allCorrectMessage } = response;

      const allCorrect = data.correct > 0 && data.totalErrors === 0;

      if (allCorrect) {
        data.allCorrectMessage = allCorrectMessage;
      }
      yield put(productsMassiveUploadSetVerify(response.data));
      yield call(summaryModal, message, false);
    } else {
      yield put(productsMassiveUploadClearVerify());
    }
  } catch (error) {
    yield productsMassiveUploadClearVerify();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield productsMassiveUploadClearVerify();
      source.cancel('cancelled Request');
    }
  }
}

function* workProductsMassiveUploadRequestUpload({ payload }) {
  const { history, fileString, overwrite } = payload;
  const CancelToken = instance.CancelToken;
  const source = CancelToken.source();
  try {
    const response = yield call(productsMassiveUpload, {
      cancelToken: source.token,
      data: {
        content: fileString,
        save: true,
        overwrite,
      },
    });
    if (responseOK(response)) {
      yield call(summaryEndModal, response.data, history, '/catalog/products');
    } else {
      yield put(productsMassiveUploadClearUpload());
    }
  } catch (error) {
    yield productsMassiveUploadClearUpload();
    console.error(error);
  } finally {
    if (yield cancelled()) {
      yield productsMassiveUploadClearUpload();
      source.cancel('cancelled Request');
    }
  }
}

export function* watchProductsMassiveUploadSetAllowUpload() {
  yield all([
    takeEvery(PRODUCTS_MASSIVE_UPLOAD_SET_ALLOW_UPLOAD, workProductsMassiveUploadSetAllowUpload),
  ]);
}

export function* watchProductsMassiveUploadRequestVerify() {
  yield all([
    takeEvery(PRODUCTS_MASSIVE_UPLOAD_REQUEST_VERIFY, workProductsMassiveUploadRequestVerify),
  ]);
}

export function* watchProductsMassiveUploadRequestUpload() {
  yield all([
    takeEvery(PRODUCTS_MASSIVE_UPLOAD_REQUEST_UPLOAD, workProductsMassiveUploadRequestUpload),
  ]);
}
